export const DROP_POSITION = {
    BEFORE: 'before',
    INSIDE: 'inside',
    AFTER: 'after',
};

export const DROP_THRESHOLD = {
    BEFORE: 0.5,
    AFTER: 0.75,
};
